import { MatIconModule } from '@angular/material/icon';
import { ChangeDetectionStrategy, Component, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { environment } from 'environments/environment';
interface InputProps extends FormlyFieldProps {
    uppercase: boolean,
    lowercase: boolean,
    spidlock: boolean
}

export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'mat-input' | Type<MatInputTypeComponent>;
}
@Component({
  selector: 'mat-input-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  imports: [MatIconModule, FormlyModule,  MatInputModule,    ReactiveFormsModule,    MatFormFieldModule],
  template: `
    @if (formState.editMode && !spidLock) {
    <input
      matInput
      [id]="id"
      [name]="field.name"
      [type]="type || 'text'"
      [readonly]="props.readonly"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [placeholder]="props.placeholder"
      (keydown)="onKeydown($event)"
      (keyup)="onKeyup($event)"
      (input)="onInput($event)"
    />
    }@else{
    {{field.formControl.value}}
    }
  `
})
export class MatInputTypeComponent extends FieldType<FieldTypeConfig<InputProps>> {
    get type() {
      return this.props.type || 'text';
    }

    get spidLock(){
      return this.field.options.formState.usermode=='spid' && !(this.field.model?.delega==2 || this.field.model?.tipo_id=='integrazione') && this.field.props.spidlock && environment.comune!="RAPALLO"
    }

    onKeydown(event: KeyboardEvent) {
        if (this.props.type === 'number') {
          if (['e', 'E', '+', '-','.'].includes(event.key)) {
            event.preventDefault();
          }
        }
    }

    onKeyup(event: KeyboardEvent) {

        if (this.props.uppercase) {
            this.field.formControl.setValue(this.field.formControl.value.toUpperCase());
        }
        if (this.props.lowercase) {
            this.field.formControl.setValue(this.field.formControl.value.toLowerCase());
        }
    }




    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart;
        const end = input.selectionEnd;

        if (this.props.uppercase) {
          // Trasforma in uppercase e aggiorna il valore del FormControl
          this.formControl.setValue(input.value.toUpperCase(), { emitEvent: false });
        }
        if (this.props.lowercase) {
            this.formControl.setValue(input.value.toLowerCase(), { emitEvent: false });
          }
        // Ripristina la posizione del cursore
        if(input.type == 'text'){
          input.setSelectionRange(start, end);
        }
      }


}




